import type { Dispatch, PropsWithChildren, SetStateAction } from 'react';
import { Dropdown, type DropdownChangeEvent } from 'primereact/dropdown';
import type { DataTableFilterMeta } from 'primereact/datatable';
import { getDataTableFilterValue } from '@/shared/lib/dataTableFilters';

export interface CityDropdownProps extends PropsWithChildren {
    filters?: DataTableFilterMeta;
    setFilters?: Dispatch<SetStateAction<DataTableFilterMeta>>;
    onFilterChange?: (filterData: { filters: DataTableFilterMeta }) => void;
    filterField?: string;
    options: Array<{ id?: number; value?: string | null }>;
    loading: boolean;
    className?: string;
}

/** Отображает фильтр по справочнику городов. */
export const CityDropdown = (
    {
        filters = {},
        setFilters,
        onFilterChange,
        filterField = 'cityId',
        options,
        loading,
        className = 'w-full md:w-14rem',
    }: CityDropdownProps
) => {
    const selectedCity = getDataTableFilterValue(filters, filterField) ?? null;

    /** Применяет выбранный город к поиску */
    const handleChange = (event: DropdownChangeEvent) => {
        const value: number | null = typeof event.value === 'number'
            ? event.value
            : null;

        const nextFilters: DataTableFilterMeta = { ...filters };

        if (value === null) {
            delete nextFilters[filterField];
        } else {
            nextFilters[filterField] = {
                value,
                matchMode: 'equals',
            };
        }

        if (onFilterChange) {
            onFilterChange({ filters: nextFilters });
        } else {
            setFilters?.(nextFilters);
        }
    };

    return (
        <Dropdown
            showClear
            value={selectedCity}
            options={options}
            onChange={handleChange}
            optionValue="id"
            optionLabel="value"
            placeholder="Выберите город"
            ariaLabel="Фильтр по городу"
            pt={{
                select: { 'aria-label': 'Фильтр по городу' },
                root: { 'aria-activedescendant': undefined },
            }}
            loading={loading}
            className={className}
        />
    );
};
